import {
	BaseError,
} from './BaseError';

export class GetRefreshSessionError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
